/* globals document, $, location, window, config */

$(document).ready(() => {
    const addLoginListeners = () => {
        // Clearing old on 'click' events so we don't create a bunch
        $('#mobile-menu').unbind('click');
        $('#login-button').unbind('click');
        $('#login-post-button').unbind('click');
        $('#login-reply-button').unbind('click');

        $('#mobile-menu').on('click', () => {
            $('#login-button').unbind('click');
            $('#login-button').on('click', () => {
                $.post('/sal/show-login', () => {
                    location.reload();
                });
            });
        });

        $('#login-button').on('click', () => {
            $.post('/sal/show-login', () => {
                location.reload();
            });
        });

        $('#login-post-button').on('click', () => {
            $.post('/sal/show-login', () => {
                location.reload();
            });
        });

        $('#login-reply-button').on('click', () => {
            $.post('/sal/show-login', () => {
                location.reload();
            });
        });

        $('#logout-button').on('click', () => {
            $.post('/sal/clear-dw-cookie', () => {
                location.reload();
            });
        });
    };

    if (config.iframeUrl) {
        addLoginListeners();

        $(window).on('action:ajaxify.end', () => {
            addLoginListeners();
        });
    }
});